// Home page section wrapper: keeps spacing and headings consistent across sections.
// It helps every section look consistent:
// - optional heading text at the top
// - same content width and padding
// - optional "style mode" (like a muted background)

import "../../styles/Home.css";

function Section({ id, eyebrow, title, subtitle, children, variant = "default" }) {
  // `id` lets the page jump/scroll to this section (example: `/#about`).
  // `eyebrow`, `title`, `subtitle` are the texts we may want to show at the top.
  // `children` is whatever content we put inside this section.
  // `variant` changes the look (default is "default").
  return (
    // The main wrapper for a section on the page.
    <section id={id} className={`homeSection homeSection--${variant}`}>
      {/* Keeps the content nicely aligned and not too wide */}
      <div className="homeSection__inner">

        {/* Only show the header area if at least one header text is provided */}
        {(eyebrow || title || subtitle) && (
          // The section header (top text area).
          <header className="homeSection__header">
            {/* Small label above the title (optional) */}
            {eyebrow && <p className="homeSection__eyebrow">{eyebrow}</p>}
            {/* Main heading (optional) */}
            {title && <h2 className="homeSection__title">{title}</h2>}
            {/* Short description (optional) */}
            {subtitle && <p className="homeSection__subtitle">{subtitle}</p>}
          </header>
        )}
  
        {/* The main content inside the section */}
        {children}
      </div>
    </section>
  );
}

export default Section;
